import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useTranslation } from "react-i18next";
import { DeckType } from "src/api/flashcardDecks";

interface DeckStatsTypeTabsProps {
	value: DeckType;
	onChange: (type: DeckType) => void;
}

const TABS = [
	{
		type: DeckType.KnowDontKnow,
		labelKey: "modals.deckStatistics.statsType.knowDontKnow",
		labelFallback: "Znam / nie znam",
		testId: "deck-stats-type-know-dont-know",
	},
	{
		type: DeckType.SpacedRepetition,
		labelKey: "modals.deckStatistics.statsType.spacedRepetition",
		labelFallback: "Spaced repetition",
		testId: "deck-stats-type-spaced-repetition",
	},
] as const;

export function DeckStatsTypeTabs({ value, onChange }: DeckStatsTypeTabsProps) {
	const { t } = useTranslation();
	const selectedIndex = TABS.findIndex((tab) => tab.type === value);

	return (
		<Tabs
			value={selectedIndex === -1 ? 0 : selectedIndex}
			textColor="primary"
			onChange={(_event, newValue) => onChange(TABS[newValue].type)}
			variant="scrollable"
			className="tabs"
		>
			{TABS.map(({ type, labelKey, labelFallback, testId }) => (
				<Tab
					key={type}
					className="tab size-16"
					label={
						<span className="first-letter-upper">
							{t(labelKey, labelFallback)}
						</span>
					}
					data-test-id={testId}
				/>
			))}
		</Tabs>
	);
}
